"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SuggestBox = _interopRequireDefault(require("01_core/components/materials/SuggestBox"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 地域選択部品
 * @prop {string} [value] - 選択している地域コード
 * @prop {bool} [required] - 未使用（検証は画面側で実施）
 * @prop {string} kaishaCd - 会社コード
 * @prop {function} onAreaSiteChange - 変更された拠点のデータを受け取る関数
 * @prop {boolean} [error] - エラー表示
 * @prop {React.ReactNode} [helperText] - ヘルパーテキスト
 */
class SelectAreaMaster extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      kaishaCd: '',
      areaInfo: []
    });
    _defineProperty(this, "RESULT", {
      areaCd: '',
      areaNm: ''
    });
    _defineProperty(this, "handleOnChange", value => {
      const selectArea = this.state.areaInfo.find(item => item.areaCd === value);
      if (selectArea === undefined) {
        this.RESULT.areaCd = null;
        this.RESULT.areaNm = '';
      } else {
        this.RESULT.areaCd = selectArea.areaCd;
        this.RESULT.areaNm = selectArea.areaNm;
      }
      this.props.onAreaSiteChange(this.RESULT);
    });
    this.state = _objectSpread({}, this.INIT_STATE);
    const {
      kaishaCd
    } = this.props;
    if (kaishaCd) {
      this.callApiSearch(kaishaCd);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      kaishaCd
    } = this.props;
    if (kaishaCd && prevProps.kaishaCd !== kaishaCd) {
      this.callApiSearch(kaishaCd);
    }
  }
  callApiSearch(kaishaCd) {
    const sendData = {
      kaishaCd: kaishaCd
    };
    this.props.callAPI(_APIs.AREA_SELECT_SEARCH, sendData).then(json => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        areaInfo: json.data ? json.data : []
      }));
    });
  }
  render() {
    const {
      value,
      kaishaCd,
      error,
      helperText
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: value === null ? '' : value,
      disabled: !kaishaCd,
      onChange: this.handleOnChange,
      items: this.state.areaInfo.map(data => ({
        displayName: data.areaNm,
        value: data.areaCd
      })),
      error: !!error,
      helperText: helperText
    });
  }
}
SelectAreaMaster.propTypes = {
  value: _propTypes.default.string,
  required: _propTypes.default.bool,
  kaishaCd: _propTypes.default.string.isRequired,
  onAreaSiteChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node
};
SelectAreaMaster.defaultProps = {
  required: false
};
var _default = exports.default = (0, _CallAPI.withCallAPI)(SelectAreaMaster);